import { EN_PLACELIST_TYPE } from '@/models/Search/policies/ISearchListPolicy';

export const LOCATION_NAME_KEY = 'location_name';

export const getListName = (placeListType: EN_PLACELIST_TYPE): string | undefined => {
  switch (placeListType) {
    case EN_PLACELIST_TYPE.AROUND:
      return 'Around';
    case EN_PLACELIST_TYPE.MOTEL:
      return 'Motel';
    case EN_PLACELIST_TYPE.HOTEL:
      return 'Hotel';
    case EN_PLACELIST_TYPE.PENSION:
      return 'Pension';
    case EN_PLACELIST_TYPE.GUESTHOUSE:
      return 'GuestHouse';
    case EN_PLACELIST_TYPE.AREA:
      return 'OldLocal';
  }
};

export const getKinesisPageName = (placeListType: EN_PLACELIST_TYPE): string => {
  if (placeListType === EN_PLACELIST_TYPE.MOTEL) {
    return 'MTHome';
  } else if (placeListType === EN_PLACELIST_TYPE.GUESTHOUSE) {
    return 'GHHome';
  }
  return 'RegionList';
};

export const getContentsName = (contentsTypeCode: number): string => {
  switch (contentsTypeCode) {
    case 0:
      return 'All';
    case 1:
      return 'Motel';
    case 2:
      return 'Hotel';
    case 3:
      return 'Pension';
    case 4:
      return 'GuestHouse';
    default:
      return 'Unknown';
  }
};
